// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f4ae1655","389":"dbba26a5","732":"95483e29","977":"28a05b08"}[chunkId] + ".chunk.js";
};